import { Box, Stack } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { DRAWER_WIDTH } from "src/assets/data/initialData";
import useUserCheck from "src/layouts/useUserCheck";
import Cookies from "js-cookie";
import { UserContext } from "src/contexts/UserContext";
import ScrollTop from "../components/ui/scroll-top/ScrollTop";
import useGetLegal, { useGetMeLegal } from "src/services/MainLayout/useGetLegal";
import useGetReal, { useGetMeReal } from "src/services/MainLayout/useGetReal";
import { Footer, Header, Sidebar } from "./AVC_Main/AVCMain";
import { LoadingScreen } from "src/components/ui";

const MainLayout = ({ children }) => {
  //const { clearUserData } = useAAA();
  //const { setNewTabItems, setNewTabContent, setTab } = useContext(MenuContext);
  const {
    isLoggedin,
    //setIsLoggedin,
    setUsername,
    setRealLegal,
    setUserType,
    setProfileId,
    setUserId,
    setLastName,
    setName,
    setNational,
    setThumbnail,
    setThumbnailUrl,
    //clearAll,
  } = useContext(UserContext);
  const navigate = useNavigate();
  const { loginStatus } = useUserCheck();
  const [loading, setLoading] = useState(true);

  const { data: dataLegalMe, loading: loadingGetMeLegal } = useGetMeLegal(
    !(isLoggedin && Cookies.get("tdlvjnhdj") === "oizxhonc9uwhfijhbiuwefADHBFIUdhcijbcdw")
  );
  const { data: dataRealMe, loading: loadingGetMeReal } = useGetMeReal(
    !(isLoggedin && Cookies.get("tdlvjnhdj") === "oijusahdfijuhaswfiuhwfouweqrufojhwdfiu")
  );
  const { data: dataLegal, loading: loadingGetLegal } = useGetLegal(
    !(isLoggedin && Cookies.get("tdlvjnhdj") === "oizxhonc9uwhfijhbiuwefADHBFIUdhcijbcdw")
  );
  const { data: dataReal, loading: loadingGetReal } = useGetReal(
    !(isLoggedin && Cookies.get("tdlvjnhdj") === "oijusahdfijuhaswfiuhwfouweqrufojhwdfiu")
  );

  useEffect(() => {
    loginStatus();
    if (
      Cookies.get("tdlvjnhdj") === "oizxhonc9uwhfijhbiuwefADHBFIUdhcijbcdw" ||
      Cookies.get("tdlvjnhdj") === "oijusahdfijuhaswfiuhwfouweqrufojhwdfiu"
    ) {
      navigate("/");
      setLoading(false);
    } else {
      navigate("/login");
    }

    if (typeof window === "undefined") {
      const isPhone = window.innerWidth <= 767;
      if (isPhone) {
        window.location.href = process.env.REACT_APP_MOBILE_URL;
      }
    }
  }, []);

  useEffect(() => {
    if (dataRealMe?.me?.username?.length) {
      setUsername(dataRealMe?.me?.username);
      setUserId(dataRealMe?.me?.id);
      setRealLegal(dataRealMe?.me?.realLegal);
      setUserType(dataRealMe?.me?.userType);
      setProfileId(dataRealMe?.me?.profileId);
      setLoading(false);
    }
    if (dataLegalMe?.me?.username?.length) {
      setUsername(dataLegalMe?.me?.username);
      setUserId(dataLegalMe?.me?.id);
      setRealLegal(dataLegalMe?.me?.realLegal);
      setUserType(dataLegalMe?.me?.userType);
      setProfileId(dataLegalMe?.me?.profileId);
      setLoading(false);
    }
  }, [dataLegalMe, dataRealMe]);

  useEffect(() => {
    if (dataReal?.getReal?.firstName?.length) {
      setLastName(dataReal?.getReal?.lastName);
      setName(dataReal?.getReal?.firstName);
      setNational(dataReal?.getReal?.nationalCode);
      setThumbnail(dataReal?.getReal?.thumbnail);
      setThumbnailUrl(dataReal?.getReal?.thumbnailUrl);
      setLoading(false);
    }
    if (dataLegal?.getLegal?.name?.length) {
      setName(dataLegal?.getLegal?.name);
      setNational(dataReal?.getLegal?.nationalId);
      setThumbnail(dataReal?.getLegal?.thumbnail);
      setThumbnailUrl(dataReal?.getLegal?.thumbnailUrl);
      setLoading(false);
    }
  }, [dataLegal, dataReal]);

  return (
    <Box sx={{ backgroundColor: "grey.gs", display: "flex", height: "100vh" }}>
      <ScrollTop />
      <Sidebar />
      <Header />
      <Box
        component="main"
        sx={{
          overflow: "hidden",
          flexGrow: 1,
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          pl: 1.5,
          mt: `calc(${DRAWER_WIDTH + 24}px)`,
          mb: `calc(${DRAWER_WIDTH - 44}px)`,
          mx: 1.5,
          borderRadius: (theme) => `${theme.shape.borderRadius * 3}px`,
        }}
      >
        <Stack
          sx={{
            height: "100%",
            position: "relative",
            backgroundColor: "grey.gb",
            borderRadius: "inherit",
            overflow: "hidden",
            mb: 1.5,
          }}
        >
          <Outlet />
        </Stack>
        <Footer />
      </Box>
      <LoadingScreen
        title={"لطفا منتظر بمانید"}
        open={loadingGetLegal || loadingGetMeLegal || loadingGetMeReal || loadingGetReal || loading}
      />
    </Box>
  );
};

export default MainLayout;
